export default {
    MFO: '14',
    LOAN: '28',
    LOAN_FREE: '58',
    AUTO_CREDIT: '2',
    HR: '40',
    CREDIT_CARD: '4',
    DEBIT_CARD: '27',
    BAIL_LOAN: '34',
    CONSUMER_LOAN: '16',
    MORTGAGE: '8',
    BETTING: '39',
    DEPOSIT: '6',
    RKO: '50',
};
